import { render, staticRenderFns } from "./the-header-brand.vue?vue&type=template&id=e45a9a22&scoped=true"
import script from "./the-header-brand.vue?vue&type=script&lang=js"
export * from "./the-header-brand.vue?vue&type=script&lang=js"
import style0 from "./the-header-brand.vue?vue&type=style&index=0&id=e45a9a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45a9a22",
  null
  
)

export default component.exports